import Hoverable from 'components/Hoverable'
import { useTheme } from 'modules/styles'
import { STYLES_COLOR } from 'modules/styles/constants/index.cjs'
import React from 'react'
import Link from 'components/Link'
import getStyleComponentUtil from 'modules/component/utils/get-style'
import { getObjectUtil } from 'packages/src'

/**
 * @param props
 * @param props.height
 * @param props.d
 * @param props.w
 * @param props.linkStyles
 * @param props.hoverableProps
 * @return {Element}
 * @constructor
 */
export default function Button (props) {
  const {
    height,
    d,
    w,
    linkStyles,
    hoverableProps = {},
    ...rest
  } = props
  const theme = useTheme()

  const handleClick = (event, name) => {
    const { onClick } = rest
    if (!onClick) {
      return
    }
    onClick(event, name)
  }

  let onClick = rest.onClick
  const {
    isDisabled,
    color,
    url,
    style,
    isFullWidth,
    hasNoPadding,
    ...restProps
  } = rest

  let { children } = rest

  const ariaLabel = rest['aria-label'] || rest.name || rest.label
  onClick = isDisabled ? null : handleClick
  if (url && (url.includes('gymaholic.co') || (url.startsWith('/') && !url.startsWith('//')))) {
    children = (
      <Link
        onClick={onClick}
        to={url}
        aria-label={ariaLabel}
        style={{
          textDecoration: 'none',
          display: 'flex',
          height: height || theme.heights.button,
          lineHeight: height || theme.heights.button,
          width: '100%',
          justifyContent: 'center',
          alignItems: 'center',
          color: color || getObjectUtil(rest.style, 'color'),
          ...(linkStyles || {})
        }}
      >
        {children}
      </Link>
    )
  } else if (url) {
    children = (
      <a
        onClick={onClick}
        href={url}
        aria-label={ariaLabel}
        style={{
          display: 'flex',
          height: height || theme.heights.button,
          width: '100%',
          justifyContent: 'center',
          alignItems: 'center',
          textDecoration: 'none',
          color: color || getObjectUtil(rest.style, 'color')
        }}
      >
        {children}
      </a>
    )
  }

  const width = (w === true ? '100%' : w) || style?.width
  return (
    <Hoverable
      d={d || 'inline-block'}
      w={width}
      isDisabled={isDisabled}
      style={{
        height: '100%'
      }}
      {...hoverableProps}
    >
      <button
        aria-label={ariaLabel}
        name={rest.name || rest.label || ariaLabel}
        type={rest.type}
        disabled={isDisabled}
        className='button'
        style={getStyleComponentUtil({
          display: 'flex',
          alignItems: 'center',
          fontFamily: 'inherit',
          height: height || theme.heights.button,
          transition: 'all 0.125s ease-out',
          cursor: 'pointer',
          maxWidth: '32em',
          width: width || (isFullWidth ? '100%' : 'auto'),
          opacity: isDisabled
            ? '0.5'
            : null
        }, style)}
        onClick={onClick}
        {...restProps}
      >
        {children}
      </button>
    </Hoverable>
  )
}

const TYPE = {
  BUTTON: 'button',
  SUBMIT: 'submit'
}

Button.COLOR = STYLES_COLOR
Button.TYPE = TYPE
